import { DateFilterEnum } from "../constants/enums";
import { RootState } from "../store";
import { RoleEnum } from "./eventTypes";

export interface iApiError {
	statusCode: number | null;
	message: string;
}

export interface iThunkApi {
	state: RootState;
	rejectValue: iApiError;
}

export enum REDUX_REQUEST_STATUS {
	FULFILLED = "fulfilled",
	PENDING = "pending",
	REJECTED = "rejected",
}
export interface iCity {
	name: string;
	bussinessId: string;
	order: number;
}

export interface IInvoice {
	id: string;
	invoiceNumber: string;
	role: RoleEnum;
	invoice: string;
}

export interface iApiSuccess {
	statusCode: number | null;
	message: string;
}

export interface IDateFilter {
	id: DateFilterEnum;
	label: string;
	startDate: Date;
	endDate: Date;
}

export interface ISelectedDateRangeFilter {
	selectedDateFilter: DateFilterEnum;
	startDate: string;
	endDate: string;
}

export interface IDropdownOption {
  id: string;
  value: string;
  disabled?: boolean;
}